import React from "react";
import { Button, Collapse, Input, Typography } from "antd";
import { RoadmapMarkdownPreview } from "./RoadmapMarkdownPreview";

const { Text } = Typography;
const { TextArea } = Input;

interface RoadmapWorkingNotesEditorProps {
  value: string;
  onChange: (value: string) => void;
  saving: boolean;
  onSave: () => void;
}

export const RoadmapWorkingNotesEditor: React.FC<RoadmapWorkingNotesEditorProps> = ({
  value,
  onChange,
  saving,
  onSave,
}) => (
  <div style={{ marginBottom: 10 }}>
    <Text strong style={{ fontSize: 13 }}>
      Working notes
    </Text>
    <Text type="secondary" style={{ display: "block", marginTop: 2, fontSize: 11, lineHeight: 1.4 }}>
      Markdown: **bold**, `code`, lists, links…
    </Text>
    <TextArea
      rows={5}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      style={{ marginTop: 6, fontFamily: "ui-monospace, monospace", fontSize: 13 }}
      placeholder="Session log: what changed, file paths, decisions, what's left for next time…"
    />
    <Collapse
      size="small"
      bordered={false}
      style={{ marginTop: 6, background: "transparent" }}
      defaultActiveKey={[]}
      items={[
        {
          key: "preview",
          label: <span style={{ fontSize: 12 }}>Markdown preview</span>,
          children: (
            <div
              style={{
                padding: "8px 10px",
                background: "#fafafa",
                border: "1px solid #f0f0f0",
                borderRadius: 8,
                maxHeight: 220,
                overflowY: "auto",
              }}
            >
              <RoadmapMarkdownPreview markdown={value} />
            </div>
          ),
        },
      ]}
    />
    <Button type="primary" size="small" loading={saving} onClick={onSave} style={{ marginTop: 6 }}>
      Save notes
    </Button>
  </div>
);
